import { useState } from 'react';

type AlertSeverity = 'error' | 'warning' | 'info' | 'success';

export function useAlert() {
  const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false);
  const [alertText, setAlertText] = useState<string>('');
  const [alertSeverity, setAlertSeverity] = useState<AlertSeverity>('error');

  const showAlert = (alertText: string, severity: AlertSeverity = 'error') => {
    setAlertText(alertText);
    setAlertSeverity(severity);
    if (alertText) {
      setIsOpenAlert(true);
    }
  };

  return {
    isOpenAlert,
    setIsOpenAlert,
    alertText,
    setAlertText,
    alertSeverity,
    showAlert
  };
}
